import { observer } from "mobx-react"
import { Button, Container, ErrorSummary, Input, Label } from "nhsuk-react-components"
import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import { withWrapper } from "../../../global/components/HOC"
import { LoaderContext } from "../../../global/components/loaderProvider"
import { Routes } from "../../../global/enums"
import { useStores } from "../../../global/hooks"
import { SetSecurityQuestion } from "../../../securityPasswordForm/components"
import "./styles.scss"

const UpdateSecurity = observer(() => {
  const { profileStore: store } = useStores()

  const [updated, setUpdated] = useState(false)
  const [currentPassword, setCurrentPassword] = useState<string>(store.currentPassword)

  const change = (e: React.FormEvent<HTMLSelectElement | HTMLInputElement>) => {
    const target = e.target as HTMLSelectElement | HTMLInputElement
    if (target) {
      store.updateSecurityData[target.name] = target.value
    }
  }
  const { wrapWithLoader } = React.useContext(LoaderContext)

  const handleSubmit = async () => {
    wrapWithLoader(async () => {
      await store.updateSecurity().then(() => setUpdated(true))
    })
  }

  useEffect(() => {
    return () => store.resetChanges()
  }, [])

  if (updated) {
    return (
      <Container className="update-security-view profile-update-page">
        <div>
          <Label isPageHeading className="update-security-view__page-heading-label">
            Your security question has been changed
          </Label>
          <Link className="update-security-view__return-link" to={Routes.ProfileUrl}>
            Go back to your account
          </Link>
        </div>
      </Container>
    )
  }

  return (
    <Container className="update-security-view profile-update-page">
      <div>
        {store.error && store.error.values.length > 0 && (
          <ErrorSummary role="alert" tabIndex={-1} style={{ marginTop: "2.5rem" }}>
            <ErrorSummary.Title id="error-summary-title">There is a problem</ErrorSummary.Title>

            <ErrorSummary.List>
              {store.error.values.map(err => {
                return err.value.map(inner => {
                  return (
                    <ErrorSummary.Item key={`${err.key}${inner.fieldError}`} href={`#${err.key}`}>
                      {inner.summaryError}
                    </ErrorSummary.Item>
                  )
                })
              })}
            </ErrorSummary.List>
          </ErrorSummary>
        )}
        <Label isPageHeading className="update-security-view__page-heading-label">
          Change your security question
        </Label>
        <Label htmlFor="input-field-currentPassword">Enter your current password</Label>
        <Input
          id="input-field-currentPassword"
          className="input-field"
          name="currentPassword"
          type="password"
          value={currentPassword}
          error={store.error.getFirstFieldError("currentPassword")}
          autoComplete="off"
          onChange={(e: React.FormEvent<HTMLInputElement>) => {
            const target = e.target as HTMLInputElement
            store.currentPassword = target.value
            setCurrentPassword(target.value)
          }}
        />
        <SetSecurityQuestion
          form={store.updateSecurityData}
          error={store.error}
          isUpdate
          onChange={change}
        />

        <div className="update-security-view__button-controls">
          <Button
            className="update-security-view__button-controls__submit-button"
            onClick={handleSubmit}
          >
            Submit
          </Button>
          <Link
            className="update-security-view__button-controls__return-link"
            to={Routes.ProfileUrl}
          >
            Go back to your account
          </Link>
        </div>
      </div>
    </Container>
  )
})

export default withWrapper(UpdateSecurity)
